// extracted by mini-css-extract-plugin
export default {"component":"jHp8Q"};